(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * Blendet die "Gute Wahl"-Bestaetigung im Cart-Drawer ein.
   *
   * Haengt am theme-eigenen on:cart:add-Event, das <product-form> nach erfolgreichem
   * Hinzufuegen feuert. Das Event kommt erst nach dem Section-Refresh, der eingeblendete
   * Zustand wird also nicht wieder wegmergt.
   */
  (() => {
    const VISIBLE_MS = 5000;
    let hideTimer = null;

    document.addEventListener('on:cart:add', () => {
      const box = document.querySelector('[data-hp-cart-confirm]');
      if (!box) return;

      // Klasse kurz entfernen und einen Reflow erzwingen, damit die Einblend-Animation
      // auch beim zweiten und dritten Hinzufuegen erneut laeuft.
      box.classList.remove('is-visible');
      void box.offsetWidth;
      box.classList.add('is-visible');

      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => box.classList.remove('is-visible'), VISIBLE_MS);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
